import type { FC } from "react";
import React, { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Footer from "../footer";
import SearchFilesHome from "../searchfileshome";
import GallerySwiper from "../galleryswiper";
import PressReleaseHome from "../pressreleasehome";

const HomePageNipau: FC = () => {
  const [pageLoaded, setPageLoaded] = useState<boolean>(false);
  const [visitorName, setVisitorName] = useState<string>("");
  const [user] = useState(JSON.parse(localStorage.getItem("user") || "{}"));
  const navigate = useNavigate();
  const [pressReleases, setPressReleases] = useState<Array<any>>([]);

  const userGroups = user.groups;
  const userFirstname = user.firstname;

  const getgroups = useCallback(async () => {
    const storedJWT = localStorage.getItem("jwt");
    await fetch(process.env.REACT_APP_API_URL + "/get-all-groups.php", {
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: "Bearer " + storedJWT,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        //check if data is an array
        if (!Array.isArray(data)) {
          return;
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  const getPressReleases = useCallback(async () => {
    const storedJWT = localStorage.getItem("jwt");
    await fetch(process.env.REACT_APP_API_URL + "/get-pressreleases.php", {
      method: "POST",
      mode: "cors",
      headers: {
        Authorization: "Bearer " + storedJWT,
      },
      body: JSON.stringify({ limit: 2 }),
    })
      .then((response) => response.json())
      .then((data) => {
        //check if data is an array
        if (!Array.isArray(data)) {
          return;
        }
        console.log(data);
        setPressReleases(data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  useEffect(() => {
    if (userGroups?.includes(0) || userGroups?.includes(1)) {
      getgroups();
    }
    userFirstname && setVisitorName(userFirstname);
    getPressReleases();
    setPageLoaded(true);
  }, [getPressReleases, getgroups, userFirstname, userGroups]);

  const galleryArray = [
    "/nipau/gallery/Nipau-Missoni.png",
    "/nipau/gallery/Nipau-Innate.png",
    "/nipau/gallery/Nipau-Alonpi.png",
    "/nipau/gallery/Nipau-Amini.png",
  ];
  const brandsArray = [
    {
      image: "/nipau/brands/alonpi.png",
      path: "/alonpi",
      title: "Alonpi",
    },
    {
      image: "/nipau/brands/amini.png",
      path: "/amini",
      title: "Amini",
    },
    {
      image: "/nipau/brands/innate.png",
      path: "/innate",
      title: "Innate",
    },
    {
      image: "/nipau/brands/missoni.png",
      path: "/missoni",
      title: "Missoni",
    },
  ];

  return (
    pageLoaded && (
      <>
        <div className="px-5 lg:px-20 md:px-10">
          <div className="container mx-auto ">
            <div className="relative ">
              <GallerySwiper images={galleryArray} />
              <div className="absolute z-10 w-full p-5 md:w-auto top-1/2 -translate-y-2/4 left-1/2 -translate-x-2/4">
                <h2 className="text-xl text-center text-white md:text-2xl lg:text-4xl">
                  Welcome{` ` + visitorName},
                  <br />
                  to the Nipau library
                </h2>
                <div className="mt-5">
                  <SearchFilesHome path={"/"} />
                </div>
              </div>
            </div>
            <div className="my-10 md:my-20 lg:my-20 xl:my-32">
              <h2 className="flex md:mb-7 flex-wrap min-h-[2rem] mb-3 gap-2  items-center text-xl md:text-2xl">
                Merken
              </h2>
              <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4 md:gap-7">
                {brandsArray?.map((brand) => (
                  <div
                    onClick={() => {
                      navigate(`/files${brand.path}`);
                    }}
                    className="px-8 py-8 rounded-md cursor-pointer bg-shade"
                  >
                    <div className="flex justify-start mb-5">
                      <img
                        src={brand.image}
                        className="inline-block w-full"
                        alt={brand.title}
                      />
                    </div>

                    <button className="flex items-center gap-2 mt-5 transition cursor-pointer hover:text-gray-500">
                      <span>view more</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-5 h-5 mt-1"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
                        />
                      </svg>
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <div className="my-10 md:my-20 lg:mt-10 lg:mb-20 xl:mt-20 xl:mb-32">
              <div className="flex items-center justify-between mb-3 md:mb-7">
                <h2 className="flex  flex-wrap min-h-[2rem]  gap-2  items-center text-xl md:text-2xl">
                  Press
                </h2>
                <button
                  onClick={() => navigate("/press-releases")}
                  className="flex items-center gap-2 text-sm transition cursor-pointer md:text-base hover:text-gray-500"
                >
                  <span>view more</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5 mt-1"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
                    />
                  </svg>
                </button>
              </div>
              <div className="grid gap-7 lg:grid-cols-2">
                {pressReleases.map((pressRelease, index) => (
                  <PressReleaseHome
                    pressrelease={pressRelease}
                    key={`pressrelease-${index}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    )
  );
};
export default HomePageNipau;
